import { CircularProgress, Stack, Typography } from "@mui/material";
import type { CheckAuthAndRedirectProps } from "../model";

export const CheckAuthAndRedirectUi: React.FC<CheckAuthAndRedirectProps> = (
  props,
) => {
  return props.authenticateStatus === "loading" ? (
    <Stack alignItems="center" justifyContent="center">
      <CircularProgress />
    </Stack>
  ) : props.authenticateStatus === "error" ? (
    <Stack alignItems="center" justifyContent="center" spacing={2}>
      <Typography variant="h6">
        申し訳ありません。エラーが発生しました。
      </Typography>
      <Typography variant="body1">
        再度ログインしてください。問題が解消しない場合は、弊社カスタマーサポートまでご連絡ください。
      </Typography>
      <Typography variant="body1">{props.message}</Typography>
    </Stack>
  ) : (
    props.children
  );
};
